import React, { Dispatch, SetStateAction } from 'react';
import './service-request.css';
import { useIntl } from 'react-intl';
import {
    newOrderUrl,
    reviewRecentOrdersUrl,
} from '../../../api/service-request-api';
import { Navigation } from '../../../global-functions';

interface IServiceRequestSubmittedProps {
    setSubmitted: Dispatch<React.SetStateAction<boolean>>;
}
const ServiceRequestSubmitted = ({
    setSubmitted,
}: IServiceRequestSubmittedProps) => {
    const intl = useIntl();

    return (
        <>
            <div className="col-xs-9">
                <h1>
                    {intl.formatMessage({
                        id: 'Your_Service_Request_Form_Has_Been_Created',
                        defaultMessage:
                            'Your Service Request Form Has Been Created',
                    })}
                </h1>
                <p>
                    {intl.formatMessage({
                        id: 'You_may_create_a_new_order_or_edit_your_current_order',
                        defaultMessage:
                            'You may create a new order or edit your current order',
                    })}
                </p>
                <div
                    className="pull-left"
                    style={{ marginRight: '5px', marginBottom: '5px' }}
                >
                    <button
                        id="new-order"
                        type="button"
                        className="btn btn-default btn-submitted"
                        onClick={() => Navigation.pushExternal(newOrderUrl)}
                    >
                        {intl.formatMessage({
                            id: 'New_order',
                            defaultMessage: 'New Order',
                        })}
                    </button>
                </div>
                <div className="pull-left" style={{ marginRight: '5px' }}>
                    <button
                        id="edit-current-order"
                        type="button"
                        className="btn btn-default btn-submitted"
                        onClick={() => setSubmitted((prev) => !prev)}
                    >
                        {intl.formatMessage({
                            id: 'Edit_Current_Order',
                            defaultMessage: 'Edit Current Order',
                        })}
                    </button>
                </div>
                <div className="pull-left">
                    <button
                        id="review-recent-orders"
                        type="button"
                        className="consent-button"
                        onClick={() =>
                            Navigation.pushExternal(reviewRecentOrdersUrl)
                        }
                    >
                        {intl.formatMessage({
                            id: 'Review_Recent_Orders',
                            defaultMessage: 'Review Recent Orders',
                        })}
                    </button>
                </div>
            </div>
        </>
    );
};

export default ServiceRequestSubmitted;
